"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getImageFromImageGroup = exports.findImageGroupBy = exports.configureDISBaseLink = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _queryString = _interopRequireDefault(require("query-string"));
var _utils = require("pwa-kit-react-sdk/ssr/universal/utils");
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; } /*
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                          * Copyright (c) 2022, salesforce.com, inc.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                          * All rights reserved.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                          * SPDX-License-Identifier: BSD-3-Clause
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                          * For full license text, see the LICENSE file in the repo root or https://opensource.org/licenses/BSD-3-Clause
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                          */ // @ts-ignore
/**
 * Find the ImageGroup that matches the criteria supplied
 *
 * @param {Object} imageGroups - The product/variations image groups you want to search.
 * @param {Object} options - Search criteria to match on the ImageGroup object.
 * @param {string} options.viewType - Typically this refers to image sizes like small, medium, large. But can vary based on your back-end configuration.
 * @param {Object} options.selectedVariationAttributes - A key/value object consisting of attibute id's and their values.
 * @returns {Object} - The ImageGroup matching the search criteria
 */
const findImageGroupBy = (imageGroups = [], options) => {
  let {
    viewType,
    selectedVariationAttributes = {}
  } = options;

  // Start by filtering out any imageGroup that isn't the correct viewType.
  imageGroups = imageGroups.filter(({
    viewType: imageGroupViewType
  }) => imageGroupViewType === viewType);

  // Not all variation attributes are reflected in images. For example, you probably
  // won't have a separate image group for various sizes, but you might for colors. For that
  // reason we need to know what are valid attribute values to filter on.
  const refinableAttributeIds = [...new Set(imageGroups.reduce((acc, {
    variationAttributes = []
  }) => [...acc, ...variationAttributes], []).map(({
    id
  }) => id))];

  // Update the `selectedVariationAttributes` by filtering out the attributes that have no
  // representation in this imageGroup.
  selectedVariationAttributes = Object.keys(selectedVariationAttributes).reduce((acc, curr) => {
    // @ts-ignore
    return refinableAttributeIds.includes(curr) ? _objectSpread(_objectSpread({}, acc), {}, {
      [`${curr}`]: selectedVariationAttributes[curr]
    }) : acc;
  }, {});

  // Find the image group that has all the all the selected variation value attributes.
  // @ts-ignore
  imageGroups = imageGroups.find(({
    variationAttributes = []
  }) => {
    const selectedIds = Object.keys(selectedVariationAttributes);
    return selectedIds.every(selectedId => {
      const selectedValue = selectedVariationAttributes[selectedId];
      return variationAttributes.find(({
        id,
        values
      }) => id === selectedId &&
      // @ts-ignore
      values.every(({
        value
      }) => value === selectedValue));
    });
  });
  return imageGroups;
};

/**
 * @param {string} disBaseLink Dynamic Image Service Link
 * @param {number|null} options.scaleWidth Width to scale
 * @param {number|null} options.scaleHeight Height to scale
 * @param {number|null} options.quality Compression Quality
 * @returns {string} Modified Dynamic Image Service Link
 */
exports.findImageGroupBy = findImageGroupBy;
const configureDISBaseLink = (disBaseLink = null, options) => {
  if (disBaseLink) {
    var _currentParams;
    const {
      scaleWidth = null,
      scaleHeight = null,
      quality = 80
    } = options || {};
    const disBaseLinkParts = disBaseLink.split('?');
    const baseDisBaseLink = disBaseLinkParts[0];
    const disBaseLinQuery = disBaseLinkParts[1] ? `?${disBaseLinkParts[1]}` : null;
    let currentParams = {};
    if (disBaseLinQuery) {
      currentParams = _queryString.default.parse(disBaseLinQuery);
    }
    let params = {
      q: ((_currentParams = currentParams) === null || _currentParams === void 0 ? void 0 : _currentParams.q) || quality
    };
    if (scaleWidth) {
      var _currentParams2;
      // @ts-ignore
      params.sw = ((_currentParams2 = currentParams) === null || _currentParams2 === void 0 ? void 0 : _currentParams2.sw) || scaleWidth;
    }
    if (scaleHeight) {
      var _currentParams3;
      // @ts-ignore
      params.sh = ((_currentParams3 = currentParams) === null || _currentParams3 === void 0 ? void 0 : _currentParams3.sh) || scaleHeight;
    }

    // @ts-ignore
    disBaseLink = `${baseDisBaseLink}?${_queryString.default.stringify(params)}`;
  }
  return disBaseLink;
};

/**
 * @param {Object} imageGroup Image Group to get the image from
 * @param {number} index Index of the image in the array
 * @param {number|null} options.scaleWidth Width to scale
 * @param {number|null} options.scaleHeight Height to scale
 * @param {number|null} options.quality Compression Quality
 * @returns {string} Image Link URL
 */
exports.configureDISBaseLink = configureDISBaseLink;
const getImageFromImageGroup = (imageGroup = null, index = 0, options) => {
  const {
    scaleWidth = null,
    scaleHeight = null,
    quality = 80
  } = options || {};
  let image = (0, _utils.getAssetUrl)('static/img/fallback-product-image.png');
  if (imageGroup) {
    // @ts-ignore
    if (imageGroup.images[index] && imageGroup.images[index].disBaseLink) {
      // @ts-ignore
      image = configureDISBaseLink(imageGroup.images[index].disBaseLink, {
        scaleWidth,
        scaleHeight,
        quality
      });
      // @ts-ignore
    } else if (imageGroup.images[index] && imageGroup.images[index].link) {
      // @ts-ignore
      image = imageGroup.images[index].link;
    }
  }
  return image;
};
exports.getImageFromImageGroup = getImageFromImageGroup;